import React from 'react';
import PropTypes from 'prop-types';
import PaymentInformationFiservCheckDisplay from './PaymentInformationFiservCheckDisplay';
import PaymentInformationFiservCreditDisplay from './PaymentInformationFiservCreditDisplay';

const PaymentInformationFiservDisplay = ({ source }) => {
	if (!source.fiserv) return null;
	switch ((source.fiserv.fundingCategory || '').toLowerCase()) {
		case 'check':
			return <PaymentInformationFiservCheckDisplay fiserv={source.fiserv} />;
		default:
			return <PaymentInformationFiservCreditDisplay fiserv={source.fiserv} cardNumber={source.cardNumber} />;
	}
};

PaymentInformationFiservDisplay.propTypes = {
	source: PropTypes.object.isRequired
};

export default PaymentInformationFiservDisplay;
